import {
  AffiliateApplication,
  AffiliateApplicationFormConfig,
  AffiliateApplicationFormField,
  AffiliateApplicationPagination,
  AffiliateApplicationStatus,
  IdentifierType,
} from '../domain/affiliate-application-types';

export interface AffiliateApplicationResponse {
  id: string;
  project_id: string;
  user_identifier: string;
  user_identifier_type: IdentifierType;
  status: AffiliateApplicationStatus;
  form_responses: Record<string, string | number | boolean | string[]>;
  admin_notes?: string;
  rejection_reason?: string;
  processed_by_user_id?: string;
  processed_at?: string;
  assigned_tier?: {
    id: string;
    name: string;
    slug: string;
    rank: number;
  };
  created_at: string;
  updated_at: string;
}

export interface GetAffiliateApplicationsResponse {
  applications: AffiliateApplicationResponse[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
  };
}

export interface AffiliateApplicationFormConfigResponse {
  id: string;
  projectId: string;
  formFields: AffiliateApplicationFormField[];
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export const transformAffiliateApplication = (dto: AffiliateApplicationResponse): AffiliateApplication => ({
  id: dto.id,
  projectId: dto.project_id,
  userIdentifier: dto.user_identifier,
  userIdentifierType: dto.user_identifier_type,
  status: dto.status,
  formResponses: dto.form_responses,
  adminNotes: dto.admin_notes,
  rejectionReason: dto.rejection_reason,
  processedByUserId: dto.processed_by_user_id,
  processedAt: dto.processed_at,
  assignedTier: dto.assigned_tier,
  createdAt: dto.created_at,
  updatedAt: dto.updated_at,
});

export const transformAffiliateApplicationFormConfig = (
  dto: AffiliateApplicationFormConfigResponse,
): AffiliateApplicationFormConfig => ({
  id: dto.id,
  projectId: dto.projectId,
  formFields: dto.formFields,
  enabled: dto.enabled,
  createdAt: dto.createdAt,
  updatedAt: dto.updatedAt,
});

export const transformGetAffiliateApplicationsResponse = (
  response: GetAffiliateApplicationsResponse,
): { applications: AffiliateApplication[]; pagination: AffiliateApplicationPagination } => ({
  applications: response.applications.map(transformAffiliateApplication),
  pagination: {
    page: response.pagination.page,
    limit: response.pagination.limit,
    total: response.pagination.total,
    totalPages: response.pagination.total_pages,
  },
});
